import React from 'react'
import Layout from '../../Components/InvestorLayout'
 import InvestorCompanyDetail from '../../Components/Investor/InvestorDetailPage/InverstorIncubationCompanyDetail'
 import RefineSearch from '../../Components/RefineSearchComponent'
 import InvestorCard from '../../Components/Investor/InvestorDetailPage/InvestorIncubationDetailCard'
 import ChatIcon from '../../images/Group 13/png/Group 13.png';
import chatPopupIcon from '../../images/chatPopupIcon.png'
import ChatPopup from '../../Components/ChatPopup'
import { INVESTOR_COMPANY_PROFILE, INVESTOR_CARD_QUERY } from '../../Queries/Pe'
import InvestorAngelRefineSearch from '../../Components/RefineSearch/InvestorAngelRefineSearch'
import useModule from '../../hooks/useModule'
import Constants from '../../Constants'
import { routeNames } from '../../routeSegments'

/**
 * The InvestorAngelDetail function is a React component that renders a layout with a primary and
 * secondary column, displaying investor company details and a refine search component respectively.
 * @returns The InvestorAngelDetail component is returning a JSX element.
 */
function InvestorAngelDetail() {
    const [showModal, setShowModal] = React.useState(false);
    const {primaryMasterId} = useModule();
    
    return ( 
        <div>
            <Layout>
            <div className="flex h-screen flex-col">
                    {/* <Card DEATAILPAGE_CARD={DEATAILPAGE_CARD}/> */}
                    {/* <InvestorCard INVESTOR_CARD_QUERY={INVESTOR_CARD_QUERY} /> */}
                    <div className="flex min-h-0 mt-[3.8rem] md:mt-[3.2rem] flex-1 overflow-hidden">
                        {/* Primary column */}
                        <section
                            aria-labelledby="primary-heading"
                            className="flex h-full min-w-0 flex-1 flex-col overflow-y-auto lg:order-last bg-[#EDEDED]">
                            {/* <CompanyDetail COMPANY_PROFILE={COMPANY_PROFILE}  /> */}
                            <InvestorCompanyDetail COMPANY_PROFILE={INVESTOR_COMPANY_PROFILE } page="angel" type="Angel Investments"/>
                            
                        {/* <Outlet /> */}
                        {/* Your content */}
                        </section>
                        {/* Secondary column (hidden on smaller screens) */}
                        <aside className="order-first block flex-shrink-0">
                            <div className="relative flex h-full  flex-col overflow-hidden scrollbar-none border-r border-gray-200 bg-[#FAF5EA]">
                                {/* Your content */}
                                <RefineSearch>
                                    <InvestorAngelRefineSearch 
                                    haveTopCard={false}
                                    customPathname={primaryMasterId === Constants.primaryMasterIds.peId
                                        ? routeNames.pe_investors_angel_investments
                                        : routeNames.vc_investors_angel_investments}/>
                                </RefineSearch>
                            </div>
                        </aside>
                    </div>
                    <br/>
                    
                </div>
            </Layout>
        </div>
    )
}

export default InvestorAngelDetail